import React from "react";
import {LocationsPage} from "./LocationsPage";

export default ()=>{
    return (<LocationsPage/>)
}